import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_h37p547xcx: FaireBrandEntity = {
  token: "b_h37p547xcx",
  type: "brand",
  name: "Oh My Mahjong",
  avatarUrl:
    "https://cdn.faire.com/fastly/3ca170cc216a6e6c5f0200061230b5f9aec93ade862e98e079226384cc2d861c.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/3034847d65cc2b64ff1d98a6b695c456eeb12d9bc81e069d6e9ee03e4f45615c.png",
  logoUrl:
    "https://cdn.faire.com/fastly/3ca170cc216a6e6c5f0200061230b5f9aec93ade862e98e079226384cc2d861c.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3034847d65cc2b64ff1d98a6b695c456eeb12d9bc81e069d6e9ee03e4f45615c.png",
  location: "Dallas, TX, USA",
  minimumOrderDollars: 2000,
  rating: 4.9,
  reviewCount: 59,
  isTopShop: true,
  isInsider: true,
  description:
    "Megan was first introduced to Mahjong by her roommate in college, and playing became a favorite pastime between studying. Twenty years later and living in Dallas, luck led her to a group of women who also played the game. During Covid, this group began meeting weekly to play Mahjong, and have continued ever since.\n\nAs a painter, Megan launched the Oh My Mahjong brand to bring her own happy, colorful designs to this traditional game. She based her “OG Line” on the original Mahjong set she was given when she graduated college. Her second line for the brand features bright painted hearts from Megan’s “What You Love” artwork series. Her lines grow and expands just like her love of the game. She hopes that her modern take on Mahjong will encourage a new generation of players to make their own tradition.\n\nOh My Mahjong's Wholesale Policy can be found at https://ohmymahjong.com/pages/wholesale-policy",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:10.406Z",
    importedBy: "entity-db-cli",
  },
};
